import { render } from "./ProductDetailsHeader.vue?vue&type=template&id=45ed432e&scoped=true&lang=true"
import script from "./ProductDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ProductDetailsHeader.vue?vue&type=script&lang=js"

import "./ProductDetailsHeader.vue?vue&type=style&index=0&id=45ed432e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ed432e"]])

export default __exports__